'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Inserter = require('../Inserter');
var FunctionClass = require('./Function');

var JSDoc = function () {
  /**
   * Constructor
   * @param {Object[]} meta
   * @param {Object[][]} inspect
   * @param {Object[]} [inspect[][].params]
   * @param {string} [inspect[][].params[].type]
   * @param {Array|Object} [inspect[][].params[].params]
   * @param {Object} [inspect[][].returns]
   * @param {string} [inspect[][].returns.type]
   * @param {Object} [inspect[][].returns.param]
   * @param {string} [inspect[][].returns.param.type]
   */
  function JSDoc(meta, inspect) {
    _classCallCheck(this, JSDoc);

    this.functions = meta.map(function (func, funcIndex) {
      return new FunctionClass(func, inspect[funcIndex]);
    });
  }

  /**
   * Write
   * @param {string} source
   * @returns {string}
   */


  _createClass(JSDoc, [{
    key: 'write',
    value: function write(source) {
      if (!this.functions.length) {
        return source;
      }
      var inserter = new Inserter(source);
      this.functions.forEach(function (func) {
        inserter.insert(func.toString(), func.pos, func.pos + func.comment.length);
      });
      return inserter.source;
    }
  }]);

  return JSDoc;
}();

module.exports = JSDoc;


//////////////////
// WEBPACK FOOTER
// ../lib/JSDoc/index.js
// module id = 496
// module chunks = 0